import { Variants } from 'framer-motion'
import { LightColors } from './Types'
import AOG058XXX from '../Assets/walkways/AOG058XXX.svg'
import AOG059XXX from '../Assets/walkways/AOG059XXX.svg'
import AOG061XXX from '../Assets/walkways/AOG061XXX.svg'
import AOG131XXX from '../Assets/walkways/AOG131XXX.svg'
import AOG133XXX from '../Assets/walkways/AOG133XXX.svg'
import AOG138XXX from '../Assets/walkways/AOG138XXX.svg'
import AOG139XXX from '../Assets/walkways/AOG139XXX.svg'
import AOG140XXX from '../Assets/walkways/AOG140XXX.svg'
import AOG136XXX from '../Assets/walkways/AOG136XXX.svg'
import AOG137XXX from '../Assets/walkways/AOG137XXX.svg'
import AOG141XXX from '../Assets/walkways/AOG141XXX.svg'
import AOG135XXX from '../Assets/walkways/AOG135XXX.svg'

import { ProjectionImage } from '../Components/Pickers/ImageModalPicker'

export const walkways: ProjectionImage[] = [
	{
		id: 'AOG058XXX',
		uri: AOG058XXX,
	},
	{
		id: 'AOG059XXX',
		uri: AOG059XXX,
	},
	{
		id: 'AOG061XXX',
		uri: AOG061XXX,
	},
	{
		id: 'AOG131XXX',
		uri: AOG131XXX,
	},
	{
		id: 'AOG133XXX',
		uri: AOG133XXX,
	},
	{
		id: 'AOG138XXX',
		uri: AOG138XXX,
	},
	{
		id: 'AOG139XXX',
		uri: AOG139XXX,
	},
	{
		id: 'AOG140XXX',
		uri: AOG140XXX,
	},
	{
		id: 'AOG136XXX',
		uri: AOG136XXX,
	},
	{
		id: 'AOG137XXX',
		uri: AOG137XXX,
	},
	{
		id: 'AOG141XXX',
		uri: AOG141XXX,
	},
	{
		id: 'AOG135XXX',
		uri: AOG135XXX,
	},
]

export const lightColors: LightColors = {
	yellow: '#f5b01e',
	none: '#00000000',
	blue: '#1526ff',
	green: '#09b21d',
	red: '#f74343',
	white: '#ffffff',
}
const colorTransition = {
	duration: 0.4,
	ease: 'easeInOut',
}

export const stopAnimationVariants: Variants = {
	yellow: {
		stopColor: lightColors['yellow'],
		transition: colorTransition,
	},
	blue: {
		stopColor: lightColors['blue'],
		transition: colorTransition,
	},
	green: {
		stopColor: lightColors['green'],
		transition: colorTransition,
	},
	red: {
		stopColor: lightColors['red'],
		transition: colorTransition,
	},
	white: {
		stopColor: lightColors['white'],
		transition: colorTransition,
	},
	none: {
		stopColor: lightColors['none'],
		transition: colorTransition,
	},
}

export const fillAnimationVariants = {
	yellow: {
		fill: lightColors['yellow'],
		transition: colorTransition,
	},
	blue: {
		fill: lightColors['blue'],
		transition: colorTransition,
	},
	green: {
		fill: lightColors['green'],
		transition: colorTransition,
	},
	red: {
		fill: lightColors['red'],
		transition: colorTransition,
	},
	white: {
		fill: lightColors['white'],
		transition: colorTransition,
	},
	none: {
		fill: lightColors['none'],
		transition: colorTransition,
	},
}
